import React, { useRef } from 'react';

import { CircularProgress } from '@material-ui/core';
import Button, { ButtonProps } from '@material-ui/core/Button';
import { darken, makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import { ITheme } from 'styles';

const roundedProps = {
  none: 'none',
  basic: '10px',
  hard: '50px',
  full: '50%',
  'basic-left': '10px 0 0 10px',
  'basic-right': '0 10px 10px 0',
  'basic-bottom': '0 0 10px 10px',
};
export type PersonalColorOptions =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'warning'
  | 'info'
  | 'success'
  | 'inherit'
  | 'default';

type CustomButtonProps = Omit<ButtonProps, 'color'> & {
  rounded?: keyof typeof roundedProps;
  width?: string | number;
  height?: string | number;
  padding?: string | number;
  extraClassName?: string;
  text?: string;
  loading?: boolean;
  icon?: JSX.Element | null;
  color?: PersonalColorOptions;
  customDisable?: boolean;
  loadingProps?: any;
  [index: string]: any;
};

// TO DO:
// Refactor: Use default colors and add general styles
/* eslint-disable */
const useStyles = makeStyles<ITheme, CustomButtonProps>(themeProps => ({
  root: props => {
    // props.variant ===
    const defaultColor = themeProps.palette[props?.color || 'primary'];
    const variantProps = {
      text: {
        backgroundColor: 'transparent',
        color: defaultColor.main,
        '&:hover': {
          color: themeProps.palette.getContrastText(defaultColor.dark),
          backgroundColor: 'transparent',
        },
      },
      outlined: {
        backgroundColor: themeProps.palette.inherit.main,
        borderColor: defaultColor.main,
        color: defaultColor.main,
        '&:hover': {
          backgroundColor: darken(themeProps.palette.inherit.main, 0.05),
          color: defaultColor.dark,
          borderColor: defaultColor.dark,
        },
        '&:disabled': {
          borderWidth: 2,
        },
      },
      contained: {
        '&:disabled': {
          backgroundColor: props.customDisable ? defaultColor.dark : themeProps.palette.inherit.dark,
          color: themeProps.palette.inherit.light,
        },
      },
    };

    return {
      borderRadius: roundedProps?.[props.rounded || 'basic'],
      width: props?.width || '100%',
      minWidth: props?.minWidth || '64px',
      height: props?.height || '45px',
      whiteSpace: 'nowrap',
      textTransform: 'none',
      fontFamily: "Roboto, sans-serif",
      fontSize: '14px',
      fontWeight: 700,
      borderWidth: 2,
      padding: props?.padding || '0 30px',
      color: props.color === "inherit" ? themeProps.palette.inherit.dark : themeProps.palette.inherit.light,
      backgroundColor: defaultColor.main,
      '&:hover': {
        color: props.color === "inherit" ? "black" : themeProps.palette.getContrastText(defaultColor.dark),
        backgroundColor: props.color === "inherit" ? themeProps.palette.inherit.light : defaultColor.dark,
      },
      ...(props.customDisable && {
        backgroundColor: defaultColor.dark,
        color: themeProps.palette.inherit.light,
      }),
      ...variantProps[props.variant || 'contained'],
    };
  },
}));

export function CustomButton(props: CustomButtonProps) {
  const {
    width = '100%',
    loading = false,
    rounded = 'basic',
    extraClassName = '',
    text = '',
    icon: Icon = null,
    color: _color,
    children,
    ...rest
  } = props;
  const classes = useStyles(props);
  const buttonClasses = classnames(classes.root, extraClassName);
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <Button ref={buttonRef} disabled={loading} classes={{ root: buttonClasses }} {...rest}>
      {!loading && Icon}
      {!loading && text}
      {!loading && children}
      {loading && (
        // <CircularProgress
        //   size={32}
        //   style={{
        //     color: '#36beb6',
        //     position: 'absolute',
        //     zIndex: 10,
        //     margin: 'auto',
        //   }}
        // />
        <div 
          className="sync-loader"
          style={{
            width: buttonRef?.current?.style.width || '170px',
            height: buttonRef?.current?.style.height || '40px',
          }}
        >
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      )}
    </Button>
  );
}
